import React from "react";
import { Link } from "react-router-dom";

import { SIContext } from "../../Context/SIContext";
import LinkButton from "../LinkButton";

import { SiHomeassistantcommunitystore } from "react-icons/si";
import { RiWaterPercentFill } from "react-icons/ri";
import { FaClipboardList } from "react-icons/fa";
import { IoMenu } from "react-icons/io5";
import { HiMiniShoppingCart } from "react-icons/hi2";

import styles from "./MenuBar.module.css";

function MenuBar() {
  const { exibeMenu, corSecundary, corPrimary, nomeEmpresa, productsCart } =
    React.useContext(SIContext);

  if (!exibeMenu) return <></>;

  return (
    <div className={styles.wrapper}>
      <nav className={styles.navBar}>
        <LinkButton
          title="Inicio"
          link={`/${nomeEmpresa}`}
          Icon={SiHomeassistantcommunitystore}
        />
        <LinkButton
          title="Promoções"
          link={`/${nomeEmpresa}/promocao`}
          Icon={RiWaterPercentFill}
        />

        {/* Central Cart Button */}
        <div className={styles.cartItemWrapper}>
          <Link to={`/${nomeEmpresa}/carrinho`} className={styles.cartIconLink}>
            <div className={styles.cartCircle} style={{ backgroundColor: corPrimary }}>
              <HiMiniShoppingCart size="22" color={corSecundary} />
              {productsCart?.length > 0 && (
                <span className={styles.cartBadge}>{productsCart?.length}</span>
              )}
            </div>
          </Link>
        </div>

        <LinkButton
          title="Pedido"
          link={`/${nomeEmpresa}/pedidos`}
          Icon={FaClipboardList}
        />
        <LinkButton
          title="Opções"
          link={`/${nomeEmpresa}/opcoes`}
          Icon={IoMenu}
        />
      </nav>
    </div>
  );
}

export default MenuBar;
